var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.766 482.766",
    style: {
      enableBackground: "new 0 0 482.766 482.766"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5D7B4"
    },
    points: "145.383,79.262 81.383,79.262 81.383,151.369 145.383,105.024  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.383,
    y: 252.678,
    style: {
      fill: "#FFE6D2"
    },
    width: 0.002,
    height: 146.584
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6D2"
    },
    d: "M241.387,102.059L81.383,217.92v181.342h320V217.918L241.387,102.059z M241.431,360.089 c-40.629-18.837-85.692-65.008-85.692-103.422c0-27.743,22.49-50.233,50.233-50.233c13.842,0,26.373,5.601,35.459,14.657 c9.086-9.056,21.617-14.657,35.459-14.657c27.743,0,50.233,22.49,50.233,50.233C327.123,295.082,282.06,341.252,241.431,360.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E86464"
    },
    d: "M276.89,206.434c-13.842,0-26.373,5.601-35.459,14.657c-9.086-9.056-21.617-14.657-35.459-14.657 c-27.743,0-50.233,22.49-50.233,50.233c0,38.414,45.063,84.584,85.692,103.422c40.629-18.837,85.692-65.008,85.692-103.422 C327.123,228.924,304.633,206.434,276.89,206.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEA087"
    },
    d: "M465.385,431.262h-8.002h-432h-7.998c-4.418,0-8,3.582-8,8s3.582,8,8,8h448c4.418,0,8-3.582,8-8 S469.803,431.262,465.385,431.262z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.383,
    y: 47.262,
    style: {
      fill: "#A03C3C"
    },
    width: 80,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2B496"
    },
    points: "457.383,431.262 457.383,399.262 449.385,399.262 449.383,399.262 401.383,399.262  81.383,399.262 33.383,399.262 25.383,399.262 25.383,431.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5D7B4"
    },
    points: "81.383,399.262 81.383,217.92 33.385,252.676 33.385,225.637 33.383,225.638  33.383,399.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5D7B4"
    },
    points: "401.383,217.918 401.383,399.262 449.383,399.262 449.383,252.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2B496"
    },
    points: "241.387,75.02 33.385,225.637 33.385,252.676 81.383,217.92 241.387,102.059  401.383,217.918 449.383,252.676 449.385,252.678 449.385,225.639  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A03C3C"
    },
    points: "241.387,75.02 449.385,225.639 464,236.223 482.766,210.301 241.387,35.504  145.383,105.024 81.383,151.369 0,210.301 18.766,236.223 33.383,225.638 33.385,225.637  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSvg);
export default __webpack_public_path__ + "static/media/HouseSVG.427e25eac09716a63504a26e5b2ad760.svg";
export { ForwardRef as ReactComponent };